import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from "@angular/forms";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {
  public form: FormGroup;
  public submitted = false;
  public isEdit = false;
  public num1: any;
  public num2: any;
  public num3: any;
  public num4: any;
  public otp:any
  public userEmail;
  public user: any;
  public email:any;
  spinnerType = SPINNER.circle;
  constructor(private ngxService: NgxUiLoaderService, public fb: FormBuilder, public authenticationService: AuthenticationService, public router: Router) {
   }
  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'))
    this.userEmail = ''
    if(!this.userEmail) {
      this.userEmail = this.user.email;
    }

    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]]
    })
    this.form.setValue({
      email: this.userEmail
    });

  }
  get f() { return this.form.controls; }

  merchantMessage() {
      const requestData = {
        days: [
          { is24Hours: true, EndTime: "", dayName: "Sundays", StartTime: "", isDaysSelected: true },
          { is24Hours: true, isDaysSelected: true, StartTime: "", EndTime: "", dayName: "Monday" },
          { isDaysSelected: true, dayName: "Tuesday", is24Hours: true, EndTime: "", StartTime: "" },
          { dayName: "Wednesday", is24Hours: true, StartTime: "", isDaysSelected: true, EndTime: "" },
          { isDaysSelected: true, StartTime: "", EndTime: "", is24Hours: true, dayName: "Thursday" },
          { is24Hours: true, dayName: "Friday", isDaysSelected: true, EndTime: "", StartTime: "" },
          { StartTime: "", isDaysSelected: true, EndTime: "", dayName: "Saturday", is24Hours: true }
        ],
        welcomeMessages: "is here to serve you",
        radius: 50
      };

      this.authenticationService.campusGreeting(requestData).subscribe(
        (response: any) => {
          console.log('API Response:', response);
        },
        (error: any) => {
          console.error('API Error:', error);
        }
      );
    }

  public verifyEmail(): void {
    let obj = {varificationCode: parseInt(this.otp)}
    console.log(obj)
    this.ngxService.start();
    this.authenticationService.verifyEmail(obj).subscribe(
      (response: any) => {
        this.ngxService.stop();
         let data = response['data'];
         let info = { email: this.email, name: '' }
              localStorage.setItem('merchant_user', JSON.stringify(info));
         this.router.navigate(["/dashboard"]);
         this.merchantMessage();
         this.createLog();
        //  localStorage.removeItem('merchant_user');
         Swal.fire(
          "",
           "Email is verified sucessfully!",
          "success"
        );
      },
      error => {
        this.ngxService.stop();
        // this.router.navigate(["/profile"]);
        if (error) {
          Swal.fire('Oops...', error.error.message, "error")
        }
      }
    );

  }
  edit() {
    this.isEdit = !this.isEdit;
    this.form.setValue({
      email: this.userEmail
    });
  }
  public updateEmail(values: Object): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    // if (this.form.valid) {
    let email = this.form.get('email').value
    let obj = { email: email }
    this.ngxService.start();
    this.authenticationService.updateEmail(obj).subscribe(
      (response: any) => {
        Swal.fire('', 'Email is updated sucessfully!', 'success')
        this.isEdit = false;
        this.getMerchantProfile(this.user.id);
        this.ngxService.stop();
      },
      error => {
        if (error) {
          this.isEdit = false;
          Swal.fire('Oops...', error.error.message, "error")
        }
        this.ngxService.stop();
      }
    );
    // }
  }

  public resendEmail(): void {
    let obj = { email:this.userEmail }
    this.ngxService.start();
    this.authenticationService.resendEmail(obj).subscribe(
      (response: any) => {
        this.ngxService.stop();
        Swal.fire('', 'OTP sent', 'success')
      },
      error => {
        if (error) {
          Swal.fire('Oops...', error.error.message,"error")
          this.ngxService.stop();
        }
      }
    );

  }
  onOtpChange(otp) {
    this.otp = otp;
    console.log(this.otp)
  }

  public getMerchantProfile(id): void {
    this.authenticationService.getMerchantById(id).subscribe(
      (data: any) => {
        let user = data['data'];
        this.userEmail = user.email;
        console.log(user, 'fffff')
        if(user.isFirstUpdateDone == true && user.isEmailVarified == true) {
          // this.router.navigate(["/dashboard"]);
          Swal.fire(
            "",
             "User is logged in sucessfully.",
            "success"
          );
         }
      },
      error => {
        if (error) {
          Swal.fire('Oops...', error.error.message,"error")
        }
      }
    );
  }


  createLog() {
    let obj = {
      userType: "Merchant",
      logType: 'signup',
      userId: this.user?.id
    }
    try {
      this.authenticationService
      .createLog(obj)
      .subscribe((res: any) => {
        if (res.code == 200) {

        }
      });
    }
    catch(error) {
      console.error(error)
    }
  }



}

